import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { IoSearchOutline } from "react-icons/io5";
import Grid, { GridHeader, GridRow } from "../../components/Grid/Grid";
import ShareService from "../../Services/ShareService";
import WebService from "../../Services/WebService";
import CountryDelete from "../../components/CountryDelete/CountryDelete";
import Loader from "../../components/Loader/Loader";
import { toast } from "react-toastify";

const Countries: React.FC = () => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [ShowLoader, setShowLoader] = useState(false);
  const [FilterObj, setFilterObj] = useState<any>({});
  const [Count, setCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [request, setRequest] = useState<any>("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const item = useParams();
  const [permissions, setPermissions] = useState({
    can_create: false,
    can_read: false,
    can_update: false,
    can_delete: false,
  });
  const navigate = useNavigate();
  useEffect(() => {
    console.log(item);
    const prevFilter: any = ShareService.getMapValue("listing-country-filter");
    if (prevFilter) {
      setFilterObj(prevFilter);
      setSearchKeyword(prevFilter.keyword || "");
      getlist(
        prevFilter.offset ? prevFilter.offset + 1 : 1,
        prevFilter.keyword,
        prevFilter.order_by,
        prevFilter.sort_by
      );
    } else {
      getlist(1);
    }
  }, []);

  const onchange = (currentPage: number, searchText?: string) => {
    let obj: any = { ...FilterObj };
    obj.offset = currentPage ? currentPage - 1 : 0;
    obj.keyword = searchText !== undefined ? searchText : searchKeyword;
    ShareService.setMapValue("listing-country-filter", obj); // ✅ save
    setFilterObj(obj);
    getlist(currentPage, obj.keyword);
  };

  // Sorting
  const onSort = (sortKey: string, order: string, sort_by: any) => {
    console.log("orderrrr", order);

    const obj: any = { ...FilterObj };
    const orderBy = order ? "asc" : "desc";
    obj.sort_by = sort_by;
    obj.order_by = orderBy;

    ShareService.setMapValue("listing-country-filter", obj);
    setFilterObj(obj);

    getlist(1, obj.keyword, orderBy, sort_by);
  };
  const getlist = (
    page: number,
    searchText?: string,
    order_by?: string,
    sort_by?: string
  ) => {
    setShowLoader(true);

    const obj: any = { ...FilterObj };
    obj.offset = page ? page - 1 : 0;
    obj.keyword = searchText ?? "";

    if (order_by) obj.order_by = order_by;
    if (sort_by) obj.sort_by = sort_by;

    setFilterObj(obj);
    ShareService.setMapValue("listing-country-filter", obj);

    const queryParams = new URLSearchParams({
      keyword: obj.keyword || "",
      sort_by: obj.sort_by || "",
      order_by: obj.order_by || "",
      offset: obj.offset.toString(),
      limit: "10",
    }).toString();

    WebService.getAPI({ action: `/country/list?${queryParams}` })
      .then((res: any) => {
        setShowLoader(false);
        setCount(res.count);
        let mappedPermissions = {
          can_create: false,
          can_read: false,
          can_update: false,
          can_delete: false,
        };

        if (Array.isArray(res.access) && res.access.length > 0) {
          const accessEntries: any[] = [];
          res.access.forEach((a: any) => {
            if (Array.isArray(a.role_access) && a.role_access.length) {
              accessEntries.push(...a.role_access);
            } else if (Array.isArray(a.access) && a.access.length) {
              accessEntries.push(...a.access);
            } else {
              accessEntries.push(a);
            }
          });

          const getMenuCode = (x: any) =>
            x?.menus?.code ??
            x?.menues?.code ??
            x?.menu?.code ??
            x?.code ??
            null;
          const getMenuId = (x: any) =>
            x?.menu_id ?? x?.menus?.id ?? x?.menues?.id ?? x?.id ?? null;

          const truthy = (v: any) => {
            if (v === true) return true;
            if (v === 1 || v === "1") return true;
            if (String(v).toLowerCase() === "true") return true;
            return false;
          };

          console.log("DEBUG: flattened accessEntries:", accessEntries);

          const matchByCode = accessEntries.find(
            (entry: any) =>
              !!getMenuCode(entry) &&
              String(getMenuCode(entry)).toLowerCase() === "manage_airports"
          );
          const matchById = accessEntries.find(
            (entry: any) => getMenuId(entry) == 10
          );

          const accessItem = matchByCode || matchById;

          if (accessItem) {
            mappedPermissions = {
              can_create: truthy(accessItem.can_create),
              can_read: truthy(accessItem.can_read),
              can_update: truthy(accessItem.can_update),
              can_delete: truthy(accessItem.can_delete),
            };
            console.log(
              "DEBUG: matched access item:",
              accessItem,
              "mappedPerms:",
              mappedPermissions
            );
          } else {
            console.warn(
              "WARN: no matching menu found in accessEntries for manage_airports or menu_id 10"
            );
          }
        } else {
          console.warn("WARN: res.access missing or empty:", res.access);
        }

        setPermissions(mappedPermissions);
        const rows: GridRow[] = res.list.map((page: any, i: number) => ({
          data: [
            { value: obj.offset === 0 ? i + 1 : 10 * obj.offset + i + 1 },
            { value: page.name },
            { value: page.code },
             { value: renderCertificationStatus(page.certification_enabled) },
            { value: actionList(page, mappedPermissions) },
          ],
        }));

        setRows(rows);
      })
      .catch(() => setShowLoader(false));
  };
  const showAccessDenied = () => {
    toast.error("Access Denied");
  };
const renderCertificationStatus = (value: any) => {
  const isEnabled =
    value === true ||
    value === 1 ||
    value === "1" ||
    String(value).toLowerCase() === "true";

  return (
    <span
      className={`badge ${
        isEnabled ? "bg-success" : "bg-danger"
      }`}
    >
      {isEnabled ? "ON" : "OFF"}
    </span>
  );
};

  const handleDelete = (id: any, perms?: any) => {
    const p = perms ?? permissions;
    console.log("handleDelete called. perms:", p, "id:", id);

    if (!p?.can_delete) return showAccessDenied();
    setShowModal(true);
    setRequest(id);
  };
  const actionList = (data: any, perms: any) => {
    const p = perms ?? permissions;
    return (
      <div className="action-btns text-left">
        {p.can_update ? (
          <a
            onClick={() => navigate(`/country/${data.uuid}`)}
            className="text-dark p-1 me-1"
            title="Edit"
          >
            <FiEdit size={18} />
          </a>
        ) : (
          ""
        )}

        {/* DELETE */}
        {p.can_delete ? (
          <button
            className="text-danger btn btn-link p-1"
            title="Delete"
            onClick={() => handleDelete(data.uuid, p)}
          >
            <FiTrash2 size={18} />
          </button>
        ) : (
          ""
        )}

      
      </div>
    );
  };

  const headers: GridHeader[] = [
    { title: "Sr No", class: "text-center" },
    {
      title: "Country Name",
      class: "text-center",
      isSorting: true,
      sortingKey: "name",
    },
    {
      title: "Code",
      class: "text-center",
      isSorting: true,
      sortingKey: "code",
    },
    {
      title: "Certification Access",
      class: "text-center",
      isSorting: true,
      sortingKey: "certification_enabled",
    },
    { title: "Action", class: "text-center" },
  ];
  const [gridHeader] = useState<GridHeader[]>(headers);

  return (
    <div className="dashboard-content">
      <Row className="mb-3 align-items-center justify-content-between">
        <Col lg={7}>
          <h1 className="font-20 font-bold mb-0">Manage Countries</h1>
        </Col>
        <Col lg={3} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <InputGroup.Text>
              <IoSearchOutline size={18} />
            </InputGroup.Text>
            <Form.Control
              id="listing-lesson-search"
              placeholder="Search..."
              value={searchKeyword}
              onChange={(e: any) => setSearchKeyword(e.target.value)}
              onKeyUp={(e: any) => getlist(1, e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col lg={2}>
            {permissions.can_create ? (
          <Link to={`/country/add`} className=" text-decoration-none">
            <button className="btn btn-brand-1 d-block mx-auto">
              + Countries
            </button>
          </Link>  ) : (
            ""
          )}
        </Col>
      </Row>

      <Loader show={ShowLoader} />

      <Row>
        <Col lg={12} sm={12} className="mt-2">
          <div
            className="p-2 card"
            style={{ marginBottom: 70, height: "100vh", overflow: "scroll" }}
          >
            {/* {permissions.can_read ? ( */}
            <Grid
              headers={gridHeader}
              rows={rows}
              count={Count}
              ShowLoader={ShowLoader}
              hoverRow={true}
              perPageItem={10}
              currentPage={FilterObj ? FilterObj?.offset + 1 : 1}
              errorMessage={"No data Found"}
              onPageChange={onchange}
              onSort={onSort}
            />  
             {/* //) : (
            //   <div className="text-center p-5">
            //     <h5 className="text-danger">Access Denied</h5>
            //   </div>
            // )} */}
          </div>
        </Col>
      </Row>

      {showModal && (
        <CountryDelete
          id={request}
          title="Are you sure you want to delete!"
          showModal={showModal}
          onCloseModel={() => {
            setShowModal(false);
            getlist(1, searchKeyword);
          }}
        />
      )}
    </div>
  );
};
export default Countries;
